import { Wrench, Lightbulb, Heart, AlertTriangle, Flag } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TicketTypeSelectorProps {
  value: string;
  onChange: (value: 'request' | 'suggestion' | 'compliment' | 'complaint' | 'report') => void;
}

const typeConfig = {
  request: {
    icon: Wrench,
    label: 'Solicitação',
    description: 'Preciso de ajuda com algo',
    color: 'text-blue-500',
    bgColor: 'bg-blue-500/10 hover:bg-blue-500/20',
    borderColor: 'border-blue-500/30',
  },
  suggestion: {
    icon: Lightbulb,
    label: 'Sugestão',
    description: 'Tenho uma ideia de melhoria',
    color: 'text-purple-500',
    bgColor: 'bg-purple-500/10 hover:bg-purple-500/20',
    borderColor: 'border-purple-500/30',
  },
  compliment: {
    icon: Heart,
    label: 'Elogio',
    description: 'Quero elogiar algo',
    color: 'text-green-500',
    bgColor: 'bg-green-500/10 hover:bg-green-500/20',
    borderColor: 'border-green-500/30',
  },
  complaint: {
    icon: AlertTriangle,
    label: 'Reclamação',
    description: 'Tenho um problema a relatar',
    color: 'text-red-500',
    bgColor: 'bg-red-500/10 hover:bg-red-500/20',
    borderColor: 'border-red-500/30',
  },
  report: {
    icon: Flag,
    label: 'Denúncia',
    description: 'Preciso denunciar algo grave',
    color: 'text-red-600',
    bgColor: 'bg-red-600/10 hover:bg-red-600/20',
    borderColor: 'border-red-600/30',
  },
};

export const TicketTypeSelector = ({ value, onChange }: TicketTypeSelectorProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {Object.entries(typeConfig).map(([key, config]) => {
        const Icon = config.icon;
        const isSelected = value === key;
        
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key as any)}
            className={cn(
              'flex items-start gap-3 p-4 rounded-lg border-2 transition-all text-left',
              'bg-white/5 hover:bg-white/10',
              isSelected ? `${config.borderColor} border-2` : 'border-white/10',
              'focus:outline-none focus:ring-2 focus:ring-luxury-red focus:ring-offset-2 focus:ring-offset-black'
            )}
          >
            <Icon className={cn('w-6 h-6 mt-0.5 flex-shrink-0', config.color)} />
            <div className="flex-1 min-w-0">
              <div className={cn('font-semibold mb-0.5 text-white', config.color)}>
                {config.label}
              </div>
              <div className="text-sm text-white/60">
                {config.description}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
